import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CookieService } from 'ng2-cookies';
import { Router } from '@angular/router';
import * as models from '../Models/projektDB.models'


@Injectable()
export class Api {
  constructor(
    private httpClient: HttpClient,
    public cookieService: CookieService,
    private router: Router,
  ) { }



  public baseUrl = '/projectDb/api/'
    public lastErrorStatusNumber: string = '';
  public lastErrorStatus: string = '';
  public lastErrorStack: string = '';
  public hasErrors: boolean = false
  public spinner = { show: false, modal: true };
  /////////////////////////////////////////////////////////// Global Error Handling \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  private handleError(error: any) {
    this.hideSpinner();
    //debugger
    //alert(error.error)
    //this.lastError = '<h5>Details: ' + error.statusText + '</h5><div>' + error.error.StackTrace + '</div>'
    //console.error('An error occurred', error);
    //this.router.navigate(['/home/globalerror']);
    debugger;
    this.lastErrorStatus = error.error.ExceptionMessage
    this.lastErrorStack = error.error.StackTrace
    this.lastErrorStatusNumber = error.status
    this.hasErrors = true

    this.router.navigate(['home/error'])
  }





  /////////////////////////////////////////////////////////// Spinner \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  private spinnerTimeOut: any

  public showSpinner() {
    let _this = this
    window.clearTimeout(_this.spinnerTimeOut)
    _this.spinnerTimeOut = window.setTimeout(function () {
      _this.spinner.show = true;
    }, 50);
  }

  public hideSpinner(callback?: any) {
    let _this = this
    window.clearTimeout(_this.spinnerTimeOut)
    _this.spinnerTimeOut = window.setTimeout(function () {
      _this.spinner.show = false;
      if (callback) { callback(); }
    }, 500);
  }

  public getIBKProjects():any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/ibkprojects';
      this.httpClient.get(url).subscribe(
        projects => {
          resolve(projects);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getKPProjects(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/kpprojects';
      this.httpClient.get(url).subscribe(
        projects => {
          resolve(projects);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getTopics(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/topics';
      this.httpClient.get(url).subscribe(
        topics => {
          resolve(topics);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getStrategyFocus(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/strategyfocus';
      this.httpClient.get(url).subscribe(
        strategyFocus => {
          resolve(strategyFocus);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getResponsible(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/responsible';
      this.httpClient.get(url).subscribe(
        strategyFocus => {
          resolve(strategyFocus);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getPartnerRegions(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/partnerregions';
      this.httpClient.get(url).subscribe(
        partnerregions => {
          resolve(partnerregions);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getSelectionCriteria(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/selectioncriteria';
      this.httpClient.get(url).subscribe(
        selectioncriteria => {
          resolve(selectioncriteria);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getInterregPeriode(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/interregperiode';
      this.httpClient.get(url).subscribe(
        interregperiode => {
          resolve(interregperiode);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getApplicantStatus(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/applicantstatus';
      this.httpClient.get(url).subscribe(
        applicantstatus => {
          resolve(applicantstatus);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getApplicantRegion(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/applicantregion';
      this.httpClient.get(url).subscribe(
        applicantregion => {
          resolve(applicantregion);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getCategory(): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/data/category';
      this.httpClient.get(url).subscribe(
        category => {
          resolve(category);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getProjectFiles(pId: string): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/files/' + pId;
      this.httpClient.get(url).subscribe(
        files => {
          resolve(files);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public saveFile(file: models.projectFiles): Promise<models.projectFiles> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/savefile';
      this.httpClient.post<models.projectFiles>(url, file).subscribe(
        file => {
          resolve(file);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getProjectLinks(pId: string): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/links/' + pId;
      this.httpClient.get(url).subscribe(
        links => {
          resolve(links);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public deleteProjectLink(link: models.projectLink): Promise<models.projectLink> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/link/delete';
      this.httpClient.post<models.projectLink>(url, link).subscribe(
        link => {
          resolve(link);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public getProjectVideos(pId: string): any {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/videos/' + pId;
      this.httpClient.get(url).subscribe(
        videos => {
          resolve(videos);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public deleteProjectVideo(video: models.projectVideo): Promise<models.projectVideo> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/video/delete';
      this.httpClient.post<models.projectVideo>(url, video).subscribe(
        video => {
          resolve(video);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public saveVideo(video: models.projectVideo): Promise<models.projectVideo> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/savevideo';
      this.httpClient.post<models.projectVideo>(url, video).subscribe(
        video => {
          resolve(video);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }


  public deleteProjectFile(file: models.projectFiles): Promise<models.projectFiles> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/file/delete';
      this.httpClient.post<models.projectFiles>(url, file).subscribe(
        cat => {
          resolve(cat);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public saveLink(project: models.projectLink): Promise<models.projectLink> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/savelink';
      this.httpClient.post<models.projectLink>(url, project).subscribe(
        link => {
          resolve(link);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public saveProject(project: models.projekt): Promise<models.projekt> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/saveproject';
      this.httpClient.post<models.projekt>(url, project).subscribe(
        cat => {
        debugger
          resolve(cat);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public saveKPProject(project: models.projekt): Promise<models.projekt> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/savekpproject';
      this.httpClient.post<models.projekt>(url, project).subscribe(
        cat => {
        debugger
          resolve(cat);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }

  public deleteProject(project: models.projekt): Promise<models.projekt> {
    return new Promise((resolve) => {
      let url: string = this.baseUrl + 'admin/deleteproject';
      this.httpClient.post<models.projekt>(url, project).subscribe(
        cat => {
          resolve(cat);
        },
        error => {
          this.handleError(error);
        }
      );
    })
  }
}
